module.exports = {
      id: "back-icon-usage",
      viewBox: "0 0 7.828 12.828",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#back-icon",
      toString: function () {
        return this.url;
      }
    }